import { CRM_AFFILIATES_URL } from 'common/api/config';
import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';

export interface FlipgiveToken {
    token: string;
}

export const getFlipgiveToken = async () => {
    const result = await withTokensIfNeeded<FlipgiveToken>(
        `${CRM_AFFILIATES_URL}/flipgive-token?api-version=1`
    );
    return result;
};
